define('responsive-gameday/views/Monitor/ViewModels/distributors/GameStateViewDistributor',['require','exports','module','message-service/message-service','../../Events/ViewModelUpdateEvents','gameday-index-url-hasher/UrlHasher','gameday-index-url-hasher/enums/HashEvents','gameday-business-rules/gameday-business-rules','jquery'],function(require,exports,module) {
    var MessageService = require("message-service/message-service"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        UrlHasher = require( "gameday-index-url-hasher/UrlHasher" ),
        HashEvents = require( "gameday-index-url-hasher/enums/HashEvents" )
        GamedayRules = require("gameday-business-rules/gameday-business-rules").getInstance();

        $ = require("jquery");
    var gameData,
      currentGame;

    exports.setGameData = function(game) {
        gameData = $.extend({}, game); // type: object

        buildSendDataPack();

        MessageService.off(UpdateEvents.REQUEST_GAMESTATE,handleUpdateRequest)
        MessageService.on(UpdateEvents.REQUEST_GAMESTATE,handleUpdateRequest);
        MessageService.off(HashEvents.GAME_STATE_CHANGED,safeToSwitch);
        MessageService.on(HashEvents.GAME_STATE_CHANGED,safeToSwitch);
    };
    
    function safeToSwitch(state){
        var game = UrlHasher.getHashParams().game;
        if(currentGame && currentGame == game){
          handleUpdateRequest();
        }
    }

    function handleUpdateRequest(){
        gameData = GDC.getGameData();
        buildSendDataPack();
    }
    // this return an Objcet
    function buildSendDataPack(state) {
      var params = UrlHasher.getHashParams();
      currentGame = params.game;

      MessageService.publish(UpdateEvents.UPDATE_GAMESTATE,{
        game_state: params.game_state,
        game      : params.game
      });
    }

      

});

